<template>
    <client-page>
        <page-section class="page-section--first page-section--sm">
            <div class="tit-wrap">
                <h2 class="tit tit--lg">
                    성장의 시간, <br />
                    <span class="primary--text">리본바이옴</span>의 도전
                </h2>
            </div>
            <p class="tit tit--sm font-weight-medium line-height-15">
                자연에서 시작된 마이크로바이옴 프로바이오틱스 기술이, <br class="d-none d-lg-block" />
                세계인의 건강을 위한 솔루션으로 발전해왔습니다.
            </p>
        </page-section>
        <page-section class="page-section--last page-section--sm">
            <ul class="history-list">
                <li v-for="item in items" :key="item.year">
                    <v-row no-gutters>
                        <v-col cols="auto">
                            <v-sheet class="history-list__year">
                                <div class="tit tit--lg line-height-1">
                                    {{ item.year }}
                                </div>
                            </v-sheet>
                        </v-col>
                        <v-col>
                            <v-sheet class="history-list__content">
                                <v-row class="row--sm">
                                    <v-col cols="12">
                                        <div class="tit tit--xs font-weight-medium line-height-15">
                                            {{ item.word }}
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row class="row--xs txt txt--lg line-height-15">
                                            <v-col v-for="child in item.text" :key="child" cols="12">
                                                <v-row no-gutters>
                                                    <v-col cols="auto" class="mr-1">·</v-col>
                                                    <v-col>
                                                        <p v-html="child" />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </li>
            </ul>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";

export default {
    components: {
        ClientPage,
        PageSection,
    },
    data() {
        return {
            items: [
                {
                    year: 2025,
                    word: "Export",
                    text: [
                        "식물성유산균 생막걸리 개발 및 살균 막걸리 수출 진행",
                        "그린바이오 기업 등록",
                        //
                    ],
                },
                {
                    year: 2023,
                    word: "Launch",
                    text: [
                        "식물성 유산균 막걸리키트 론칭",
                        //
                    ],
                },
                {
                    year: 2022,
                    word: "Establishment",
                    text: [
                        "리본바이옴 브랜드 설립 - (주)웰빙엘에스의 20년 제조 기술력을 기반으로 한 유통 및 파트너십 전문 자회사 출범",
                        //
                    ],
                },
                {
                    year: 2021,
                    word: "Diversification",
                    text: [
                        "마이크로바이옴 식물성유산균 라인업 확대",
                        //
                    ],
                },
                {
                    year: 2020,
                    word: "Launch",
                    text: [
                        "포스트바이오틱스 제품군 확대, 반려동식물 라인업 론칭",
                        //
                    ],
                },
                {
                    year: 2019,
                    word: "Outreach",
                    text: [
                        "발효커피’스타루빈’ 해외 전시회 참가 확대",
                        //
                    ],
                },
                {
                    year: 2018,
                    word: "Scale-up",
                    text: [
                        "신공장 준공, GMP 인증, 건기식생산 서울 마케팅본부 설립",
                        //
                    ],
                },
                {
                    year: 2016,
                    word: "Launch",
                    text: [
                        "포스트바이오틱스 신제품 론칭",
                        //
                    ],
                },
                {
                    year: 2014,
                    word: "Achievements",
                    text: [
                        "대한민국 우수특허 대상 수상 RUWA 상표등록",
                        //
                    ],
                },
                {
                    year: 2011,
                    word: "Launch",
                    text: [
                        "식물성유산균 도넛 브랜드 ‘웬즐리’ 런칭",
                        //
                    ],
                },
                {
                    year: 2009,
                    word: "Award",
                    text: [
                        "발효콩으로 기술혁신상 지식경제부 장관상 수상 INNO-BIZ 인증",
                        //
                    ],
                },
                {
                    year: 2008,
                    word: "Establishment",
                    text: [
                        "기업부설연구소 생명공학연구소 설립",
                        //
                    ],
                },
                {
                    year: 2006,
                    word: "Start",
                    text: [
                        "유산균 발효 공장 설립, 식물성유산균 생산 시작",
                        //
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.page-section {
    &--first {
        background: url(/images/about/history/bg.jpg) no-repeat center / cover;
    }
}
.history-list {
    &__year {
        width: 90px;
        border-top: 2px solid var(--v-grey-darken4);
        margin-right: 20px;
    }
    &__year,
    &__content {
        padding: 14px 0;
    }
    &__content {
        border-bottom: 1px solid var(--v-grey-lighten4);
    }
}
@media (min-width: 768px) {
    .history-list {
        &__year {
            width: 180px;
            margin-right: 60px;
        }
        &__year,
        &__content {
            padding: 20px 0;
        }
    }
}
</style>
